var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-col",
    { attrs: { lg: "4", md: "6", sm: "12" } },
    [
      _c(
        "cc-titled-panel",
        {
          attrs: {
            title: _vm.reserve.Name,
            icon: _vm.reserve.Icon,
            color: _vm.reserve.Color
          }
        },
        [
          _c(
            "v-card-text",
            {
              staticClass: "text-xs-left mt-0 pt-0",
              staticStyle: { height: "115px" }
            },
            [
              _c("div", { staticClass: "overline subtle--text mt-n2 mb-n1" }, [
                _vm._v(_vm._s(_vm.reserve.Type))
              ]),
              _vm._v(" "),
              _c("p", {
                staticClass: "flavor-text mb-0",
                domProps: { innerHTML: _vm._s(_vm.reserve.Description) }
              })
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }